import { FormatBold, FormatItalic, FormatClear } from '@mui/icons-material';
import {
  IconButton,
  InputLabel,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import React from 'react';
import InputField from './InputField';

const FormattedTextArea = ({
  label,
  id,
  value,
  name,
  onChange,
  required,
  ...props
}) => {
  const applyFormatting = (formatType) => {
    const textarea = document.getElementById(id);
    if (!textarea) return;

    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;

    const selectedText = textarea.value.substring(start, end);
    const leadingText = textarea.value.substring(0, start);
    const trailingText = textarea.value.substring(end);

    if (selectedText.length === 0) return;

    const removeExistingFormatting = (text) => {
      return text.replace(/<b>(.*?)<\/b>/g, '$1').replace(/<i>(.*?)<\/i>/g, '$1');
    };

    const applyNewFormatting = (text, formatType) => {
      const formattedText =
        formatType === 'bold' ? `<b>${text.trim()}</b> ` : `<i>${text.trim()}</i> `;
      return formattedText;
    };

    const cleanedSelectedText = removeExistingFormatting(selectedText);

    const newFormattedText = applyNewFormatting(
      cleanedSelectedText,
      formatType
    );

    const newValue = leadingText + newFormattedText + trailingText;

    onChange({
      target: {
        name,
        value: newValue,
      },
    });
  };

  const clearFormatting = () => {
    const removeAllFormatting = (text) => {
      return text.replace(/<b>(.*?)<\/b>/g, '$1').replace(/<i>(.*?)<\/i>/g, '$1');
    };

    const newValue = removeAllFormatting(value);

    onChange({
      target: {
        name,
        value: newValue,
      },
    });
  };

  return (
    <Stack>
      <InputLabel htmlFor={id || name}>
        {label}
        {required && '*'}
      </InputLabel>
      <Stack spacing={1} alignItems="flex-end">
        <Stack direction="row" spacing={1}>
          <Typography
            variant="caption"
            sx={{ marginRight: '8px', color: 'text.secondary' }}>
            Use <b>&lt;b&gt;&lt;&#47;b&gt;</b> for bold and <i>&lt;i&gt;&lt;&#47;i&gt;</i> for italics, or
            select text and use the buttons to apply formatting.
          </Typography>
          <Tooltip title="Bold">
            <IconButton
              onClick={() => applyFormatting('bold')}
              size="small"
              sx={{
                padding: '2px',
                minWidth: '20px',
                height: '20px',
                '& svg': { fontSize: '1.2rem' },
              }}>
              <FormatBold />
            </IconButton>
          </Tooltip>
          <Tooltip title="Italic">
            <IconButton
              onClick={() => applyFormatting('italic')}
              size="small"
              sx={{
                padding: '2px',
                minWidth: '20px',
                height: '20px',
                '& svg': { fontSize: '1.2rem' },
              }}>
              <FormatItalic />
            </IconButton>
          </Tooltip>
          <Tooltip title="Clear Formatting">
            <IconButton
              onClick={clearFormatting}
              size="small"
              sx={{
                padding: '2px',
                minWidth: '20px',
                height: '20px',
                '& svg': { fontSize: '1.2rem' },
              }}>
              <FormatClear />
            </IconButton>
          </Tooltip>
        </Stack>
        <InputField
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          type="text"
          multiline
          required={required}
          {...props}
          sx={{
            width: '100%',
            '& .MuiInputBase-root': {
              padding: '8px',
              fontSize: '14px',
              borderRadius: '4px',
            },
          }}
        />
      </Stack>
    </Stack>
  );
};

export default FormattedTextArea;
